import { AppBar, Container, Grid, Paper } from "@material-ui/core";
import { ProgressBar } from "../shared/components/progressBar";
import usePolicies from "../shared/hooks/usePolicies";
import { policiesStyles } from "./policiesStyles";
import { PRIVACY, TERMS_CONDITIONS } from "./services/policyTypes.enum";

export const Policies = () => {
  const classes = policiesStyles();
  const { policies, isLoading } = usePolicies([PRIVACY, TERMS_CONDITIONS]);

  return (
    <Grid container className={classes.container}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <AppBar className={classes.navBar}>
          <a target="_blank" href="https://meetfruition.com/" rel="noreferrer">
            <img
              className={classes.logo}
              alt="Fruition"
              src="/fruitionportal.png"
            />
          </a>
        </AppBar>
      </Grid>
      <Container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Paper className={classes.paper}>
            {isLoading && <ProgressBar />}
            {policies?.map((policy) => (
              <div
                className="ck-content"
                id={policy.policyType.replaceAll(" ", "")}
                key={`${policy.policyTypeId}-${policy.version}`}
              >
                <div dangerouslySetInnerHTML={{ __html: policy.body }} />
              </div>
            ))}
          </Paper>
        </Grid>
      </Container>
    </Grid>
  );
};
